import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import {
  BciLoaderService,
  BciSidebarService,
  SidebarNavItem
} from '@bci-web-core/core';
import { TranslateService } from '@ngx-translate/core';
import { JwtHelperService } from "@auth0/angular-jwt";
import { OAuthService } from 'angular-oauth2-oidc';
import { AccountModel, AuthUserInfo } from 'src/app/models/index';
import { AppConfigService } from 'src/app/services/app-config.service';
import { AuthService } from 'src/app/services/auth.service';
import { DataService } from 'src/app/services/data.service';
import { CommonService } from 'src/app/services/index';
import { SiteService } from 'src/app/services/site.service';
import { AlertService, AuthGuard, Constants } from 'src/app/shared/index';
import { SystemPrivacyModalComponent } from './system-privacy-modal/system-privacy-modal.component';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  providers: [DataService]
})
export class LoginComponent implements OnInit, OnDestroy, AfterViewInit {
  model: AccountModel = new AccountModel();
  captchaUrl = '';
  lang: string;
  validToken:boolean;
  jwt = new JwtHelperService();
  loadingBar: any;
  LOGIN_REDIRECT_URL = environment.loginUrl_SSO;
  LOGOUT_REDIRECT_URL = environment.logoutUrl_SSO;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private sidebarService: BciSidebarService,
    public auth: AuthGuard,
    private dataService: DataService,
    private siteService: SiteService,
    private authService: AuthService,
    private commonService: CommonService,
    public dialog: MatDialog,
    private oauthService: OAuthService,
    public translate: TranslateService,
    public appConfig: AppConfigService,
    private loader: BciLoaderService,
    private alertService: AlertService
  ) {
    this.loadingBar = this.loader.showProgressBar();
    this.lang = localStorage.getItem('lang') || 'en';
    localStorage.setItem('lang', this.lang);

    this.retrieveTokens();
  }
  public loginFromToken(tokenExternal1,tokenExternal2,tokenExternal3) {
    if (!tokenExternal1) { return false; }
    this.validToken = this.validateToken(tokenExternal1); 
     // Check wether token is valid or not
    if (!this.validToken) return this.redirectToDaimler("login"); // Token is not valid then redirect to Diamler sso
    if (this.clearLocalData()) {
      this.redirectToSiteMasterPage(tokenExternal1,tokenExternal2,tokenExternal3);
    }
  }
  public validateToken(tokenExternal) {
    if (!this.jwt.isTokenExpired(tokenExternal)) return true;
    else return false;
  }
  clearLocalData() {
    this.clearCache();
   
    return true;
  }

  sidebarLinksAdmin: SidebarNavItem[] = [];
  sidebarLinksUser: SidebarNavItem[] = [];

  clearCache() {
    localStorage.removeItem('currentUser');
    localStorage.removeItem('lastActivityTime');
    localStorage.removeItem('access_token');
    localStorage.removeItem('id_token');
    localStorage.removeItem('refresh_token');
  }
  retrieveTokens() {
    let tokenKey1FromUrl;
    let tokenKey2FromUrl;
    let tokenKey3FromUrl;

    if (this.areTokensStored()) {
      tokenKey1FromUrl = localStorage.getItem('id_token');
      tokenKey2FromUrl = localStorage.getItem('access_token');
      tokenKey3FromUrl = localStorage.getItem('refresh_token');
    } else {
      this.route.queryParamMap.subscribe(params => {
        tokenKey1FromUrl = params.get('id_token');
        tokenKey2FromUrl = params.get('access_token');
        tokenKey3FromUrl = params.get('refresh_token');

        if (!tokenKey1FromUrl || !tokenKey2FromUrl || !tokenKey3FromUrl) {
          const searchParams = new URLSearchParams(window.location.search);
          tokenKey1FromUrl = searchParams.get("id_token");
          tokenKey2FromUrl = searchParams.get("access_token");
          tokenKey3FromUrl = searchParams.get("refresh_token");
        }


      });
    }
    this.handleTokens(tokenKey1FromUrl, tokenKey2FromUrl, tokenKey3FromUrl);
  }
  areTokensStored(): boolean {
    if( localStorage.getItem('access_token') && localStorage.getItem('id_token') && localStorage.getItem('refresh_token')){
      return true;
    }
    else
      return false;
  }

  handleTokens(tokenKey1FromUrl: string, tokenKey2FromUrl: string, tokenKey3FromUrl: string) {
    if (tokenKey2FromUrl == 'null' || tokenKey1FromUrl == 'Null' ) {
      this.redirectToDaimler('logout');
    } else if (tokenKey1FromUrl === undefined || tokenKey1FromUrl === '' || tokenKey1FromUrl === null){
      setTimeout(() => {
        this.redirectToDaimler('login');
      }, 1000); 
    } else if ( tokenKey1FromUrl &&
      tokenKey1FromUrl.length > 0 &&
      tokenKey1FromUrl != "null")  {
      localStorage.setItem('id_token', (tokenKey1FromUrl))
      localStorage.setItem('access_token', (tokenKey2FromUrl))
      localStorage.setItem('refresh_token', (tokenKey3FromUrl));
      this.loader.hideProgressBar(this.loadingBar);
      this.redirectToSiteMasterPage(tokenKey1FromUrl,tokenKey2FromUrl,tokenKey3FromUrl);
    }
  }

  ngOnInit() {
    this.sidebarService.setSidebarVisibility(false);
    this.retrieveTokens();  
  }

  ngAfterViewInit() {
    this.sidebarService.setSidebarVisibility(false);
  }
  get authenticated(): boolean {
    return null;
  }

  changeLang(lang) {
    localStorage.setItem('lang', lang);
    console.log(lang);
    this.translate.use(lang);
  }

  login() {
    this.oauthService.initCodeFlow();
    this.lang = localStorage.getItem('lang');
  }

  ngOnDestroy() {
    this.sidebarService.setSidebarVisibility(true);
  }

  /**
   * Method to redirect to DFL login
   *
   * @param {string} status
   * @memberof LoginComponent
   */
  // public redirectToDaimler(status) {
  //   if (status === 'login') {
  //     this.authService.logout();
  //     this.oauthService.logOut();
  //     window.open(this.appConfig.config.redirectUri, '_self');
  //   } else {
  //     this.logout();
  //   }
  // }
  public redirectToDaimler(status) {
    let redirectExternal = (status == "login") ? this.LOGIN_REDIRECT_URL : this.LOGOUT_REDIRECT_URL;
    this.clearLocalData();
    window.open(redirectExternal, "_self");
  }

  /**
   * Method to redirect to site master page after successful login
   *
   * @param {string} token
   * @memberof LoginComponent
   */
  redirectToSiteMasterPage(token1,token2,token3) {
    this.authService.getUserDetail().subscribe((userInfo) => {
      if (userInfo !== null && !this.commonService.isNullOrUndefined(userInfo.data)) {
        let fullName = '';

        const firstName = !this.commonService.isNullOrUndefined(
          userInfo.data.firstName
        )
          ? userInfo.data.firstName
          : '';
        const lastName = !this.commonService.isNullOrUndefined(
          userInfo.data.lastName
        )
          ? userInfo.data.lastName
          : '';
        if (firstName !== '' && lastName !== '') {
          fullName = firstName + ' ' + lastName;
        }

        const authUser = new AuthUserInfo(
          token1,
          '',
          '',
          userInfo.data.username,
          fullName,
          userInfo.data.role,
          userInfo.data.flatMenus,
          0,
          userInfo.data.useSSO,
          userInfo.data.alreadyLoggedIn,
          userInfo.data.activities
        );
        localStorage.setItem('currentUser', JSON.stringify(authUser));
        this.authService.userActivities = userInfo.data.activities;
        this.authService.userRole = userInfo.data.role.name;
        this.authService.userMenus = userInfo.data.flatMenus;
        const menu = [];
        const sidebarLinksUser: SidebarNavItem[] = this.authService.buildMenus(
          this.authService.defaultMenus,
          menu,
          true,
          this.lang
        );

        this.auth.sidebarLinks = sidebarLinksUser;
        console.log('authUser.alreadyLoggedIn --> ' + authUser.alreadyLoggedIn);
        if (!authUser.alreadyLoggedIn) {
          if (this.dialog.openDialogs.length === 0) {
            this.dataService
              .getData('./assets/text/privacy.txt', true, true)
              .subscribe((data) => {
                if (data) {
                  // Incase can read -> Show policy popup
                  const dialogRef = this.dialog.open(
                    SystemPrivacyModalComponent,
                    {
                      width: '50%',
                      maxHeight: '660px'
                    }
                  );
                  dialogRef.componentInstance.privacyMessage = data;
                  dialogRef.afterClosed().subscribe((dialogData) => {
                    if (dialogData && dialogData.data) {
                      // this.authService
                      //   .takeOutFirstTimeOfUser()
                      //   .subscribe((userData) => {
                      //     console.log(userData);
                      //   });
                      this.navigate();
                    }
                  });
                } else {
                  // Incase cannot read privacy file -> Navigate
                  this.navigate();
                }
              });
          }
        } else {
          // In case: not the first time user login
          this.navigate();
        }
      } else {
        this.alertService.showError(Constants.MESSAGE.LoginFail);
      } 
    });
    this.loader.hideProgressBar(this.loadingBar);
  }

  /**
   * Method to navigate to home page based on the user roles
   *
   * @memberof LoginComponent
   */
  navigate() {
    // Store time for checking inactive user
    localStorage.setItem('lastActivityTime', new Date().getTime().toString());
    localStorage.setItem('needForceLogout', 'false');
    //
    this.siteService.getSiteDetails().subscribe((sites) => {
      if (sites) {
        if (sites.length > 1) {
          this.router.navigate(['/site-master']);
          localStorage.setItem('isMultipleSites', 'true');
        } else if (sites.length === 1) {
          const find = this.auth.sidebarLinks.find(
            (c: any) => c.code === 'HOME'
          );
          if (!this.commonService.isNullOrUndefined(find)) {
            find.url = '/site';
            localStorage.setItem('siteId', sites[0].siteId);
            localStorage.setItem('siteName', sites[0].siteName);
            localStorage.setItem('isMultipleSites', 'false');
          }
          this.router.navigate(['/site'], {
            queryParams: { siteId: sites[0].siteId }
          });
        }
      }
    });
    this.loader.hideProgressBar(this.loadingBar);
  }

  /**
   * Method to logout from the application
   *
   * @memberof LoginComponent
   */
  logout() {
    this.oauthService.logOut();
    localStorage.removeItem('currentUser');
    localStorage.removeItem('access_token');
    localStorage.removeItem('id_token');
    localStorage.removeItem('refresh_token');
    this.sidebarService.setSidebarVisibility(false);
    this.router.navigate(['/']);
  }
}
